<template>
<!-- 动画 -->
  <div class="container cartoon">
    <el-row :gutter="6" class="cartoon-list">
      <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8" v-for="(item, index) in cartoonList" :key="index">
        <div class="cartoon-item flex-align-center flex-center">
          <div class="cartoon-img" style="margin-bottom: 0">
            <el-image :src="item.image" alt="" :lazy="true">
              <div slot="placeholder" class="image-slot">
                <img :src="item.loadImg" alt="">
              </div>
            </el-image>
          </div>
          <div class="cartoon-title">
            <div class="cartoon-desc-box">
              <h2 class="cartoon-name mb5">{{ item.title }}</h2>
              <p class="cartoon-desc">{{ item.desc }}</p>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      cartoonList: [
        {
          image: 'https://cdn.renderg.com/download/www/renderg_dist/images/cartoon2.png',
          loadImg: require('../../assets/image/loadimg/cartoon2.jpg'),
          title: 'VFX',
          desc: '专属团队  定制服务',
          showTitle: false,
        },
        {
          image: 'https://cdn.renderg.com/download/www/renderg_dist/images/cartoon1.png',
          loadImg: require('../../assets/image/loadimg/cartoon1.jpg'),
          title: 'Animation',
          desc: '云端渲染  极速交付',
          showTitle: false,
        },
        {
          image: 'https://cdn.renderg.com/download/www/renderg_dist/images/cartoon3.png',
          loadImg: require('../../assets/image/loadimg/cartoon3.jpg'),
          title: 'Design',
          desc: '智能提交  一键渲染',
          showTitle: false,
        },
      ]
    }
  },
}
</script>